import { useContext } from 'react';

import { ToastContext, type ToastApi } from './toast-context';

export function useToast(): ToastApi {
  return useContext(ToastContext);
}
